import React, { useState } from 'react';
import RichText from '@johnlewispartnership/wtr-content-component-library/dist/component-library/components/RichText';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink';
import classNames from 'classnames';
import { type RecipeStateItem } from 'redux/modules/recipes/reducers';
import styles from './index.scss';

const defaultData = {
  analytics: {},
};

type RecipesDescriptionProps = {
  value: RecipeStateItem['description'];
  maxParagraphs?: number;
  disableMaxParagraphs?: boolean;
};

const RecipesDescription = ({
  value,
  maxParagraphs = 1,
  disableMaxParagraphs = false,
}: RecipesDescriptionProps) => {
  const [showAll, setShowAll] = useState(false);

  const toggleShow = () => {
    setShowAll(!showAll);
  };

  const paragraphBlocks = value.blocks?.filter(block => block.style === 'paragraph') || [];
  const blocksToShow =
    showAll || disableMaxParagraphs ? value.blocks : paragraphBlocks?.slice(0, maxParagraphs);

  return (
    <>
      <RichText
        {...defaultData}
        {...value}
        // @ts-expect-error - Type issue in wtr-content-component-library, should be fixed in a future release. Ref: WPIP-80732.
        blocks={blocksToShow}
        noMargin
        position="recipe-description"
        removeEmptyParagraphs
      />
      {paragraphBlocks.length > maxParagraphs && !disableMaxParagraphs && (
        <TextLink
          className={classNames('no-print', styles.showMoreLessToggle)}
          onClick={toggleShow}
          component="button"
          aria-label={showAll ? 'Collapse description' : 'Expand description'}
        >
          {showAll ? 'Show Less' : 'Show More'}
        </TextLink>
      )}
    </>
  );
};

RecipesDescription.displayName = 'RecipesDescription';

export default RecipesDescription;
